import { Dialog, Slide } from '@mui/material';
import React from 'react';
import { TransitionProps } from '@mui/material/transitions';
import CustomInput from '@/components/Organization/CustomInput';
import { FormProvider, useForm } from 'react-hook-form';
import { useDebounce } from 'usehooks-ts';
import RecentApproval from '@/components/MobileApproval/SearchModal/RecentApproval';
import SearchApproval from '@/components/MobileApproval/SearchModal/SearchApproval';
import { useTranslation } from 'react-i18next';
import { Container } from '@/components/MobileApproval/SearchModal/styles';
import RecentDocument from '@/components/MobileApproval/SearchModal/RecentDocument';
import SearchDocument from '@/components/MobileApproval/SearchModal/SearchDocument';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type P = {
  open: boolean;
  handleClose(): void;
  documentMode?: boolean;
};

const SearchModal = ({ open, handleClose, documentMode }: P) => {
  const methods = useForm<{ keyword: string }>({
    defaultValues: { keyword: '' },
  });
  const searchString = methods.watch('keyword');
  const debouncedValue = useDebounce(searchString, 500);
  const { t } = useTranslation();

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <FormProvider {...methods}>
        <Container>
          <div
            style={{
              paddingTop: '18px',
              display: 'flex',
              gap: '20px',
              position: 'sticky',
              top: '0',
              backgroundColor: 'var(--dk-bg, white)',
              zIndex: '4',
            }}
          >
            <CustomInput placeHolder={t('제목, 내용을 검색해 주세요.')} />
            <button
              style={{ fontSize: '14px', whiteSpace: 'nowrap' }}
              onClick={handleClose}
            >
              {t('취소')}
            </button>
          </div>
          {documentMode ? (
            debouncedValue.length > 1 ? (
              <SearchDocument keyword={debouncedValue} />
            ) : (
              <RecentDocument />
            )
          ) : debouncedValue.length > 1 ? (
            <SearchApproval keyword={debouncedValue} />
          ) : (
            <RecentApproval />
          )}
        </Container>
      </FormProvider>
    </Dialog>
  );
};
export default SearchModal;
